import React from 'react';
import Form from 'components/form';
import BrandInput from 'components/input/BrandInput';

export default function BrandField(props) {
  return <Form.Field {...props} component={BrandInput} />;
}
